<template>
    <div>
        <div class="breadcrumb-layout" name="head-block">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
                <el-breadcrumb-item>保养凭单</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="org-tree-layout" name="tree-block">
            <swb-popover-org-tree :showMgmt="true" :bizDepart="true" :showIncludeSubComs="true" :initIncludeSubComs="initIncludeSubComs" :enableSearch="true" :departFlag="false" @notity-change="notityChange($event)"></swb-popover-org-tree>
        </div>
        <div name="query-sort-block">
            <swb-query-sort-area ref="query_model_ctrl" :confKey="confKey" :configAuto="true" :queryOnLoad="queryOnLoad" :queryHandler="queryHandler" :onConfigReady="onConfigReady"></swb-query-sort-area>
        </div>
        <swb-result-table name="result_table" ref="result_table" :confKey="confKey" :configAuto="true" :needPager="needPager" :multiSelect="multiSelect" :multiPageSelect="multiPageSelect" :rowKeyPropName="rowKeyPropName"
                          :rowNoShow="rowNoShow" :rowNoFixed="rowNoFixed" :btnColName="btnColName" :btnColTitle="btnColTitle" :btnColWidth="btnColWidth" :btnColFixed="btnColFixed" :height="tableHeight"
                          :pageNoChangeHandler="pageNoChangeHandler" :rowDblClickHandler="rowDblClickHandler"></swb-result-table>

    </div>
</template>

<script>
    import {Utils, $} from '../../app.base'
    import {Vue, MsgBox, DomSizeWatcher, Routes} from '../../app.vues'
    import {checkUserActionPerm} from '../index'
    import {getDefaultPageSizes} from '../../app.conf'
    import appConf from '../../app.conf';
    import {showGrpDownloadDlg} from '../ctrl/dialog'
    import {openWorkVoucherDetailDlg} from '../workVoucher/showDetailDlg'
    import {setAssetsGroupDevcFilter} from '../asset/selectDlg'
    import {loadAssetKindList, loadRetailerDevcGroupCascList, loadRetailerShopTagList} from '../retailer/asset-comn'

    import servcDelivApi from '../../api/servcDeliv'
    import retailerApi from '../../api/retailer'
    import userApi from '../../api/user';
    import SwbResultColConf from '../query/ResultColConf.vue';
    import SwbResultTable from '../query/ResultTable.vue';

    Vue.regist(SwbResultColConf);
    Vue.regist(SwbResultTable);

    export default {
        name: 'swb-devc-maint-voucher-list',
        path: '/devc/maint/voucher/list',
        avlActions: '',
        avlScopes: 'retailer',
        desc: '维保凭单',
        data: function () {
            return {
                confKey: 'swb-devc-maint-voucher-list',
                tableHeight: 300,
                queryOnLoad: true,
                //
                needPager: true, //是否需要分页（默认：true）
                multiSelect: false, //是否多选（默认：false）
                multiPageSelect: false, //是否要多页/跨页选择（默认：false）
                rowKeyPropName: "id", //记录数据关键标识列名（多页/跨页选择必须，默认: id）
                rowNoShow: false, //是否显示行号（默认：true）
                rowNoFixed: false, //行号列是否固定（默认：false）
                btnColName: '',//操作列名称（如果不设置就不显示操作列）
                //
                btnColTitle: '操作',//操作列标题（默认：'操作'）
                btnColWidth: 120,//操作列宽度（默认：100）
                //
                btnColFixed: true, //操作列是否固定
                resultColConf: {},

                pageNumber: 1,
                totalCount: 1,
                pageSize: null,
                pageSizes: getDefaultPageSizes(),
                //
                devcMaintVoucherList: [],
                //
                queryModel: {
                    filterItems: {},
                    sortItemList: [],
                    sortItems: {}
                },
                //
                initIncludeSubComs: false,
                treeCollapse: true,
                thisComLevel: null,
                thisComId: null,
                shopFlag: null,
                scopeEntity: null,
                mgmtSmlAreaId: null
            }
        },
        created: function () {
            this.pageSize = this.pageSizes.first();
            //
            this.getCurrUserInfo();
        },
        mounted() {
            let self = this;
            //注册domSizeWatcher
            let thisEl = $(this.$el);
            $(this.$el).addClass('overflow-hidden');
            //
            let domSizeWatcher = this.domSizeWatcher = new DomSizeWatcher(Vue.$getClassInfo(this).name);
            domSizeWatcher.setBaseEl(thisEl);
            domSizeWatcher.setMainEl(thisEl.find('[name="result_table"]'), function (width, height, theEl) {
                //根据新主元素的内容大小，调整表格高度
                self.tableHeight = height;

            });
            //domSizeWatcher.setHrEls();
            domSizeWatcher.setVtEls(thisEl.find('[name="head-block"],[name="tree-block"],[name="query-sort-block"]'));
            domSizeWatcher.start(500);
            //
            this.initResultTable();

        },
        destroyed() {
            //释放domSizeWatcher
            let domSizeWatcher = this.domSizeWatcher;
            if (domSizeWatcher != null) {
                domSizeWatcher.clear();
                this.domSizeWatcher = null;
            }
        },
        methods: {
            initResultTable(){
                let self = this;
                let query_model_ctrl = this.$refs['query_model_ctrl'];
                let resultTable = this.$refs['result_table'];
                //关联[列配置对象]到结果表格（结果表格可以实时利用最新的列配置，同时结果表格列宽也会反向同步到[列配置对象]中去）
                resultTable.setQrySortRef(query_model_ctrl);
                //
                resultTable.initMeta(/* confColList, */ /* 单元格html渲染函数 */{
                    'no': function (row, colName, colValue, rowIndex, colConf) {
                        if(row.refSrcFlag == 1){
                            return '<span><a class="table-cell-link" >' + colValue + '</a></span>';
                        }
                    },
                    'svcConfirmed': function (row, colName, colValue, rowIndex, colConf) {
                        if (colValue) {
                            return '<span class="font-green">是</span>';
                        }
                    },
                    'useConfirmed': function (row, colName, colValue, rowIndex, colConf) {
                        if (colValue) {
                            return '<span class="font-green">是</span>';
                        }
                    },
                    'actions': function (row, colName, colValue, rowIndex) {
//                        let domHtml = '';
//                        if (row.pdfFileUuuid != null) {
//                            return domHtml + '<a name="viewProof" class="swb-btn swb-btn-link">预览下载</a>';
//                        }
                    }
                }, /* 单元格按钮点击处理函数 */{
                    //*代表可处理未指定事件函数的任意列的按钮/链接的点击
                    'no': function (row, colName, colValue, rowIndex, btnName) {
                        if(row.refSrcFlag == 1){
                            self.toServcWorkVoucher(row.refSrcId);
                        }
                    },
                    'actions': function (row, colName, colValue, rowIndex, btnName) {
                        if (btnName == 'viewProof') {
                            self.viewProof(row);
                        }
                    }
                });
            },
            renderTable(rows, pagination) {
                //
                let resultTable = this.$refs.result_table;
                //清除数据（如果已经渲染的数据与新的列不是一回事儿）
                //resultTable.clear();
                //同步使用新的自定义列信息
                //resultTable.initMeta(confColList);
                //设置新数据
                let tableData = {
                    rows: rows,
                    pagination: pagination
                };
                resultTable.render(tableData);
            },
            // 单元格点击事件
            rowDblClickHandler: function (row) {
                if (!this.multiSelect) {
                    console.log("----- 双击数据行 ----");
                    console.log(row);
                }
            },
            getTableSelection() {
                let resultTable = this.$refs.result_table;
                return resultTable.getSelection();
            },
            // 检查资源具体操作权限（可选的是否为指定的岗位id）
            checkActionPerm: function (action, targetPostId) {
                return checkUserActionPerm(Vue.$getClassInfo(this).path, action, targetPostId);
            },
            getCurrUserInfo(){
                let self = this;
                userApi.getUserInfoByContext({}, function (result) {
                    if (result.type == 'info') {
                        let scopeEntity = result.data.scopeEntity;
                        //
                        self.thisComLevel = scopeEntity.comLevel;
                        self.thisComId = scopeEntity.comId;
                        self.shopFlag = scopeEntity.shopFlag;
                        self.includeSubComs = false;
                        self.scopeEntity = scopeEntity;
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            notityChange: function (eventData) {
                if (eventData.id != this.thisComId || this.includeSubComs != eventData.includeSubComs) {
                    this.mgmtSmlAreaId = null;
                    if (Utils.isTrue(eventData.mgmtFlag)) {
                        let scopeEntity = this.scopeEntity;
                        this.thisComLevel = scopeEntity.comLevel;
                        this.thisComId = scopeEntity.comId;
                        this.shopFlag = scopeEntity.shopFlag;
                        this.includeSubComs = true;
                        this.mgmtSmlAreaId = eventData.id;
                    } else {
                        this.thisComLevel = eventData.level;
                        this.thisComId = eventData.id;
                        this.shopFlag = eventData.shopFlag;
                        this.includeSubComs = eventData.includeSubComs;
                    }
                    this.getDevcMaintVoucherList();
                }
            },
            queryHandler(queryModel){
                this.queryModel = queryModel;
                this.pageNumber = 1;
                //
                this.getDevcMaintVoucherList();
            },
            pageNoChangeHandler: function (pageNumber, pageSize) {
                console.log("分页 => 第【" + pageNumber + "】页，大小：" + pageSize);
                //
                this.pageSize = pageSize;
                this.pageNumber = pageNumber;
                //
                this.getDevcMaintVoucherList();
            },
            handleSizeChange: function (val) {
                let curStartIndex = (this.pageNumber - 1) * this.pageSize;
                this.pageSize = val;
                let newPageNumber = Math.max(1, Math.ceil(curStartIndex / this.pageSize));
                this.handlePageChange(newPageNumber);
            },
            handlePageChange: function (val) {
                this.pageNumber = val;
                this.getDevcMaintVoucherList();
            },
            getDevcMaintVoucherList: function () {
                let self = this;
                let postData = {};
                postData.pagination = {
                    pageSize: self.pageSize,
                    pageNumber: self.pageNumber,
                };
                //
                let queryModel = self.queryModel;
                let filterItems = Utils.merge({}, queryModel.filterItems);
                let sortItemList = Utils.merge([], queryModel.sortItemList);
                let sortItems = Utils.merge({}, queryModel.sortItems);
                //
                filterItems.buyerShopId = null;
                filterItems.buyerComId1 = null;
                filterItems.buyerComId2 = null;
                filterItems.buyerComId3 = null;
                filterItems.buyerComId4 = null;
                if (self.includeSubComs) {
                    filterItems["buyerComId" + self.thisComLevel] = self.thisComId;
                } else {
                    filterItems.buyerShopId = self.thisComId;
                }
                filterItems.mgmtSmlAreaId = self.mgmtSmlAreaId;
                // 默认为：保养凭单列表
                filterItems.appliedWorkType = 1;    // 保养
                //
                postData.filterItems = filterItems;
                postData.sortItemList = sortItemList;
                postData.sortItems = sortItems;
                //
                let theLoading = MsgBox.loading();
                servcDelivApi.getDevcMaintVoucherList(postData, function (result) {
                    theLoading.close();
                    if (result.type === "info") {
                        self.devcMaintVoucherList = result.data.rows;
                        self.totalCount = result.data.pagination.totalCount;
                        self.renderTable(result.data.rows, result.data.pagination);
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            // 跳转工单详情
            toServcWorkVoucher: function (id) {
                openWorkVoucherDetailDlg(id);
            },
            detailDialog: function () {
                MsgBox.info();
            },
            viewProof(row){
                let fileUuid = row.pdfFileUuuid;
                let fileName = '保养凭单-' + row.no + '.pdf';
                let viewUrl = appConf.makeViewableDocUrl(fileName, fileUuid);
                if (viewUrl == null) {
                    MsgBox.warning("此文件不支持在线查看！");
                }
                else {
                    Utils.setPageUrl(viewUrl, '_blank');
                }
            },
            onConfigReady(){
                let self = this;
                // 门店标签
                loadRetailerShopTagList(function (dataList) {
                    self.updateQueryModelField("buyerShopTagId", dataList);
                });
                // 分类分组
                loadRetailerDevcGroupCascList(function (dataList) {
                    self.updateQueryModelField("devcGroupId", dataList);
                });
                let no = this.$route.query.no || null;
                if (!Utils.isNoB(no)) {
                    let query_model_ctrl = this.$refs['query_model_ctrl'];
                    let fieldInfo = {
                        no: {
                            value: no
                        }
                    };
                    query_model_ctrl.updateFields(fieldInfo);
                }
            },
            updateQueryModelField: function (itemCode, dataList = []) {
                if (itemCode != null) {
                    let query_model_ctrl = this.$refs['query_model_ctrl'];
                    let data = {dataList: dataList};
                    let fieldInfo = {};
                    fieldInfo[itemCode] = data;
                    query_model_ctrl.updateFields(fieldInfo);
                }
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/compo/devcMaint/DevcMaintVoucherList.vue